import { Col, Row, Image, Typography } from 'antd';
import { Link, Outlet } from 'react-router-dom';
import Logo from './assets/auth-saha-logo.svg';
import BrowserImg from './assets/browser.svg';

const AuthLayout = () => {
  const { Title, Text } = Typography;

  return (
    <>
      <Row className='auth-layout'>
        <Col md={12} xs={0}>
          <Row style={{ height: 'calc(100vh - 64px)' }} className="auth-bg-image" justify={"start"}>
            <Col>
              <Row>
                <Col>
                  <a href='https://sahadabasari.com/'>
                    <Image width={240} preview={false} src={Logo}></Image>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Title level={1}>Kendini Keşfet Saha ile Parla</Title>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Text>Saha Eğitime hoşgeldin, eğitimini bu platform üzerinden bir üst seviyeye çıkarabilirsin.</Text>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  {/* <Image width={"600px"} style={{marginTop: 40}} preview={false} src={BrowserImg}></Image> */}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col md={12} xs={24}>
          <Row style={{ height: '100vh', maxHeight: '100vh', overflow: 'auto' }} className='p-16' justify={"center"} align={"middle"}>
            <Col xxl={14} lg={18} md={20} sm={24} xs={24}>
              <Row>
               <Col md={0} sm={24} xs={24}>
                  <a href='https://sahadabasari.com/'>
                    <Image width={240} preview={false} src={Logo}></Image>
                  </a>
                </Col>
              </Row>
              <Outlet />
              <Row justify={'center'}>
                <Col>
                  <p>
                    Bizimle çalışmak ister misiniz? <Link to={'/basvuru'}>Başvur</Link>
                  </p>
                </Col>

              </Row>
              <Row justify={'center'}>
                <Col>
                  <p>© 2024 Tüm Hakları Saklıdır</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default AuthLayout